<template lang="html">
  <el-dialog
    title="录入发票"
    width="75%"
    @close="hideDialog('reconcileBill/mu_isShowAddInvoice')"
    :visible="isShowAddInvoice"
  >
    <InvoiceEnter
      :pay-order-id-list="selectedRows.map(_ => _.payOrderId)"
      :pay-order-amount-list="selectedRows.map(_ => _.amountWithTax)"
      :added-invoice-no-list="addedInvoiceList.map(_ => _.invoiceNo)"
      :tax-rate="selectedRows[0] ? selectedRows[0].taxRate : null"
      @confirm="HandleInvoiceEnterConfirm"
      :serverCheckErrors="serverCheckErrors"
    />
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideDialog('reconcileBill/mu_isShowAddInvoice')">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { dialogCtrl } from '@/mixins'

import { mapState } from 'vuex'
import InvoiceEnter from '@/components/InvoiceEnter/index.vue'

export default {
  name: 'addInvoice',
  components: {
    InvoiceEnter,
  },
  props: ['selectedRows', 'addedInvoiceList', 'serverCheckErrors'],
  mixins: [dialogCtrl],
  computed: {
    ...mapState('reconcileBill', ['isShowAddInvoice']),
  },
  watch: {},
  methods: {
    HandleInvoiceEnterConfirm(invoiceList) {
      this.$emit('confirm', invoiceList)
    },
  },
}
</script>

<style scoped lang="scss"></style>
